import React from 'react';
import PropTypes from 'prop-types';

export default function ResetIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 15 13" {...rest}>
      <path
        fill={color}
        d="M3.37695213,6.3 L5.28711668,6.3 L2.64355834,8.94355834 L4.54747351e-13,6.3 L1.77695221,6.3 C1.77664022,4.64398364 2.42352444,3.04390781 3.62220498,1.84522728 C6.08250802,-0.615075759 10.0714474,-0.615075759 12.5317504,1.84522728 C14.9920535,4.30553032 14.9920535,8.29446968 12.5317504,10.7547727 C10.0714474,13.2150758 6.08250802,13.2150758 3.62220498,10.7547727 L4.75357583,9.62340187 C6.58904,11.458866 9.5649154,11.458866 11.4003796,9.62340187 C13.2358437,7.7879377 13.2358437,4.8120623 11.4003796,2.97659813 C9.5649154,1.14113396 6.58904,1.14113396 4.75357583,2.97659813 C3.85855602,3.87161793 3.3766389,5.06344044 3.37695213,6.3 Z"
      />
    </svg>
  );
}

ResetIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

ResetIcon.defaultProps = {
  size: 15,
  color: '#000',
};
